import { Scrollbar } from "Roblox";
import angular from "angular";
import notificationStreamModule from "../notificationStreamModule";


function lazyLoading(notificationStreamService, $document, $log) {
    "ngInject";

    return {
        restrict: "A",
        scope: true,
        link: function (scope, element, attrs) {
            scope.callbackLazyLoad = function () {
                if (!scope.notificationApiParams) {
                    return false;
                }
                if (scope.notificationApiParams.loadMoreNotifications) {
                    scope.layout.notiticationsLazyLoadingEnabled = true;
                    notificationStreamService.getRecentNotifications(
                        scope.notificationApiParams.startIndexOfNotifications,
                        scope.notificationApiParams.pageSizeOfNotifications)
                        .then(
                            function (data) {
                                scope.layout.notiticationsLazyLoadingEnabled = false;
                                if (data && data.length > 0) {
                                    scope.buildNotificationsList(data);
                                    scope.notificationApiParams.startIndexOfNotifications = scope.notificationApiParams.startIndexOfNotifications + scope.notificationApiParams.pageSizeOfNotifications;
                                    if (data.length < scope.notificationApiParams.pageSizeOfNotifications) {
                                        scope.notificationApiParams.loadMoreNotifications = false;
                                        scope.notificationApiParams.startIndexOfNotifications = 0;
                                    }
                                } else {
                                    scope.notificationApiParams.loadMoreNotifications = false;
                                    scope.notificationApiParams.startIndexOfNotifications = 0;
                                }
                            }, function () {
                                scope.layout.notiticationsLazyLoadingEnabled = false;
                                $log.debug("---error from get Notificaitons in lazyLoadingDirective.js---");
                            });
                }
            };

            scope.setupScrollbar = function () {
                element.mCustomScrollbar({
                    autoExpandScrollbar: false,
                    scrollInertia: 5,
                    contentTouchScroll: 1,
                    mouseWheel: {
                        preventDefault: true
                    },
                    callbacks: {
                        onTotalScrollOffset: 100,
                        onTotalScroll: scope.callbackLazyLoad,
                        onOverflowYNone: scope.callbackLazyLoad
                    }
                });
            }

            scope.destroyScrollbar = function () {
                $log.debug("----- destroyScrollbar ----");
                element.mCustomScrollbar("destroy");
            }
            var init = function () {
                if (scope.library.inApp) {
                    Scrollbar.setUpOverflowY(element, scope.callbackLazyLoad);
                    Scrollbar.listenToScroll($document, null, scope.callbackLazyLoad);
                } else {
                    scope.setupScrollbar();
                }
            }

            var watchPageDataInitialized = scope.$watch(
                function () {
                    return scope.layout && scope.layout.isLazyLoadingRequested;
                },
                function (newValue, oldValue) {
                    if (angular.isDefined(newValue) && newValue !== oldValue) {
                        $log.debug("----- initializeLayout ----");
                        if (newValue) {
                            init();
                        } else if (!scope.library.inApp) {
                            scope.destroyScrollbar();
                        }
                    }
                }, true
            );

            scope.$on("$destroy", function () {
                if (watchPageDataInitialized) {
                    watchPageDataInitialized();
                }
            });
        }
    }
}

notificationStreamModule.directive("lazyLoading", lazyLoading);

export default lazyLoading;